export default class QueryWhereLeftBracket
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryWhereLeftBracket";

	
	static None = "None";
	static Bracket1 = "Bracket1";
	static Bracket2 = "Bracket2";
	static Bracket3 = "Bracket3";
	static Bracket4 = "Bracket4";
		
	static valueOf(value)
	{
		if(value == "None")
			return QueryWhereLeftBracket.None;
		else if(value == "(")
			return QueryWhereLeftBracket.Bracket1;
		else if(value == "((")
			return QueryWhereLeftBracket.Bracket2;
		else if(value == "(((")
			return QueryWhereLeftBracket.Bracket3;
		else if(value == "((((")
			return QueryWhereLeftBracket.Bracket4;
		
		throw new Error("错误的枚举类型");
	}
		
	static labelOf(value)
	{
		if(value == QueryWhereLeftBracket.None || value == null)
			return "None";
		else if(value == QueryWhereLeftBracket.Bracket1)
			return "(";
		else if(value == QueryWhereLeftBracket.Bracket2)
			return "((";
		else if(value == QueryWhereLeftBracket.Bracket3)
			return "(((";
		else if(value == QueryWhereLeftBracket.Bracket4)
			return "((((";
		
		throw new Error("错误的枚举类型");
	}
	
}


// WEBPACK FOOTER //
// ./src/query/remote/QueryWhereLeftBracket.js